module.exports = function mapArrayBoundsToGeolib(bounds) {
  return {
    minLat: bounds[0][0],
    minLng: bounds[0][1],
    maxLat: bounds[1][0],
    maxLng: bounds[1][1],
  };
};
